// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__LwMAv","secondary":"Button_secondary__1sG9u","icon":"Button_icon__2b0BQ","text":"Button_text__2sRQa"};